import { type CardAccount } from '@reliance/types/models/CardAccount';
import { type ApiService } from '../types/ApiService';

export const cardAccount = (centralApi: ApiService) => ({
  get: (id: string, params): Promise<CardAccount> => {
    return centralApi.get(`/card-account/${id}`, { params });
  },
});
